var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconFilmScript = function SvgIconFilmScript(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.125 7.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M8.625 18a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3M10.125 12a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M5.25 2A1.75 1.75 0 0 0 3.5 3.75v16.5c0 .966.784 1.75 1.75 1.75h13.5a1.75 1.75 0 0 0 1.75-1.75V3.75A1.75 1.75 0 0 0 18.75 2zm.25 18V4h13v16z",
    clipRule: "evenodd"
  }))));
};
export default SvgIconFilmScript;